/**
 * Interest Level Utilities
 * Provides color mapping and behavior for person interest levels
 */
import { InterestLevel } from '@gamma/shared/attributes';

/**
 * Get the color for a given interest level
 * @param {string} level - Interest level (CRITICAL, HIGH, MEDIUM, LOW)
 * @returns {string} Hex color code
 */
export const getInterestLevelColor = (level) => {
  switch (level?.toUpperCase()) {
    case InterestLevel.CRITICAL:
      return '#d32f2f'; // red
    case InterestLevel.HIGH:
      return '#f57c00'; // orange
    case InterestLevel.MEDIUM:
      return '#fbc02d'; // yellow
    case InterestLevel.LOW:
      return '#9e9e9e'; // grey
    default:
      return '#9e9e9e'; // grey
  }
};

/**
 * Check if an interest level should pulse (animate)
 * @param {string} level - Interest level
 * @returns {boolean} True if level should pulse
 */
export const shouldInterestLevelPulse = (level) => {
  return level?.toUpperCase() === InterestLevel.CRITICAL;
};
